import { IPromotionState } from '../types';
import { IPublishTermsSuccessPayload } from '../../../../actions/publishTerms';
import { mergeServices } from './mergeServices';
import { mergeAuctionBet } from './mergeAuctionBet';
import { mergeToggle } from './mergeToggle';

// Этот костыль нужен для сохранения выбранных пользователем услуг и ставок при обновлении publishTerms
export function deprecated_mergePublishTerms(
  state: IPromotionState,
  payload: IPublishTermsSuccessPayload,
): IPromotionState {
  return {
    ...state,
    ...payload.dataV2.promotion,
    toggle: mergeToggle(state.toggle, payload),
    services: mergeServices(state, payload),
    auctionBet: mergeAuctionBet(state, payload),
  };
}
